import React, { useEffect, useState } from "react";
import SelectInput from "../common/SelectInput";
import TextAreaInput from "../common/TextAreaInput";
import TextInput from "../common/TextInput";
import IntlTelInput from 'react-intl-tel-input';

function ReceiverDetails(props) {
    const { values, errors, dirty, handleOnChange, setData, navigation, t } =
        props;
    const {
        receiverFirstName,
        receiverLastName,
        receiverEmailAddress,
        city,
        area,
        streetName,
        building,
        floor,
        apartmentNo,
        fullAddress,
        isBillingSame,
        receiverMobileNumber,
        configuration,
    } = values;

    const { locale } = values;
    const [cityLookup, setCityLookup] = useState([]);
    const [areaLookup, setAreaLookup] = useState([]);


    const {
        showNationalIdNumber,
        showPassportNumber,
        showFirstName,
        showThirdName,
        showSecondName,
        showLastName,
        showReceiptNumber,
        showReferenceNumber,
        isAttestationService
    } = configuration;
    const activeFields = [];

    if (showNationalIdNumber === 1) {
        activeFields.push("nationalIdNumber");
    }

    if (showPassportNumber === 1) {
        activeFields.push("passportNumber");
    }

    if (showReceiptNumber === 1) {
        activeFields.push("receiptNumber");
    }

    if (parseInt(showReceiptNumber) === 1) {
        activeFields.push("receiptNumber");
    }

    if (parseInt(showFirstName) === 1) {
        activeFields.push("firstName");
    }

    if (parseInt(showLastName) === 1) {
        activeFields.push("lastName");
    }

    if (parseInt(showSecondName) === 1) {
        activeFields.push("secondName");
    }

    if (parseInt(showThirdName) === 1) {
        activeFields.push("thirdName");
    }

    if (parseInt(showReferenceNumber) === 1) {
        activeFields.push("applicationReferenceNumber");
    }

    const handleCityChange = (event) => {
        handleOnChange(event);
        const cityCode = event.target.value;
        const selectedEmirate = cityLookup.find((city) => {
            return city.code === cityCode;
        });
        setData({
            name: "cityName",
            value: locale === "ar" ? selectedEmirate.nameAr : selectedEmirate.nameEn,
        });
        fetch(
            process.env.REACT_APP_MASTERS_API_BASE_URL +
            "/locations/api/Regions?EmirateId=" +
            selectedEmirate.id
        )
            .then((response) => response.json())
            .then((data) => {
                setAreaLookup(data.data.list);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleAreaChange = (event) => {
        handleOnChange(event);
        const selectedArea = areaLookup.find((area) => {
            return area.code === event.target.value;
        });
        setData({ name: "areaName", value: selectedArea.nameEn });
    };

    const isStepInvalid = () => {
        const stepInputs = [
            ...activeFields,
            "emailAddress",
            "city",
            "area",
            "streetName",
            "apartmentNo",
        ];
        const stepBillingInputs = [
            "billingFirstName",
            "billingLastName",
            "billingCity",
            "billingCountry"
        ];
        let billingNullValues = [];
        let errorBillingValues = [];
        const nullValues = stepInputs.filter((input) => {
            return values[input] === "";
        });
        const errorValues = stepInputs.filter((input) => {
            return errors[input] !== "";
        });
        if (!isBillingSame) {
            billingNullValues = stepBillingInputs.filter((input) => {
                return values[input] === "";
            });
            errorBillingValues = stepBillingInputs.filter((input) => {
                return errors[input] !== "";
            });
        }
        return nullValues.length ||
            errorValues.length ||
            billingNullValues.length ||
            errorBillingValues.length
            ? true
            : false;
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        fetch(
            process.env.REACT_APP_MASTERS_API_BASE_URL + "/locations/api/Emirates?IncludeCityAsEmirate=true"
        )
            .then((response) => response.json())
            .then((data) => {
                setCityLookup(data.data.list);
                setData([{ name: "cityLookup", value: data.data.list }]);
            });

        fetch(
            process.env.REACT_APP_MASTERS_API_BASE_URL + "/locations/api/Emirates?IncludeCityAsEmirate=true"
        )
            .then((response) => response.json())
            .then((data) => {
                setCityLookup(data.data.list);
            });

    }, []);



    return (
        <>
            <div className="receiver-section">
                <div className="row">
                    <div className="col-sm-12">
                        <h3>
                            <img src="./images/user-icon.svg" alt="User Icon" />
                            {t("RECEIVER_DETAILS")}
                        </h3>
                    </div>

                    <div className="col-sm-6 mb-3">
                        <TextInput
                            id="firstName"
                            name="firstName"
                            label={t("FIRST_NAME")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={receiverFirstName}
                            required={true}
                            validation={{ errors, dirty }}
                            maxLength={100}
                            t={t}
                        />
                    </div>

                    <div className="col-sm-6 mb-3">
                        <TextInput
                            id="lastName"
                            name="lastName"
                            label={t("LAST_NAME")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={receiverLastName}
                            validation={{ errors, dirty }}
                            maxLength={100}
                            t={t}
                        />
                    </div>

                    <div
                        className="col-sm-12 mb-3"
                    >
                        <IntlTelInput
                            preferredCountries={["ae", "fr"]}
                            containerClassName="intl-tel-input"
                            inputClassName="form-control form-control-lg"

                            value={receiverMobileNumber}
                            name="receiverMobileNumber"
                            fieldId="receiverMobileNumber"
                            fieldName="receiverMobileNumber"
                            separateDialCode={true}
                            disabled={false}
                        />
                    </div>
                    <div
                        className="col-sm-12 mb-3"
                    >
                        <TextInput
                            id="emailAddress"
                            name="emailAddress"
                            label={t("EMAIL_ADDRESS")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={receiverEmailAddress}
                            required={true}
                            validation={{ errors, dirty }}
                            maxLength={100}
                            t={t}
                        />
                    </div>

                    <div className="col-sm-6 mb-3">
                        <div className="form-group">
                            <SelectInput
                                className="form-control form-select"
                                id="city"
                                name="city"
                                label={t("CITY")}
                                onChange={handleCityChange}
                                value={city}
                                validation={{ errors, dirty }}
                                defaultText={t("SELECT_CITY")}
                                itemLookUp={cityLookup}
                                language={locale}
                                t={t}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 mb-3">
                        <div className="form-group">
                            <SelectInput
                                className="form-control form-select"
                                id="area"
                                name="area"
                                label={t("AREA")}
                                onChange={handleAreaChange}
                                value={area}
                                validation={{ errors, dirty }}
                                defaultText={t("SELECT_AREA")}
                                itemLookUp={areaLookup}
                                language={locale}
                                t={t}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 mb-3">
                        <TextInput
                            id="streetName"
                            name="streetName"
                            label={t("STREET_NAME")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={streetName}
                            validation={{ errors, dirty }}
                            maxLength={200}
                            t={t}
                        />
                    </div>
                    <div className="col-sm-6 mb-3">
                        <TextInput
                            id="building"
                            name="building"
                            label={t("BUILDING")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={building}
                            validation={{ errors, dirty }}
                            maxLength={100}
                            t={t}
                        />
                    </div>
                    <div className="col-sm-6 mb-3">
                        <TextInput
                            id="floor"
                            name="floor"
                            label={t("FLOOR")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={floor}
                            validation={{ errors, dirty }}
                            maxLength={50}
                            t={t}
                        />
                    </div>
                    <div className="col-sm-6 mb-3">
                        <TextInput
                            id="apartmentNo"
                            name="apartmentNo"
                            label={t("APARTMENT_NO_VILLA")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={apartmentNo}
                            validation={{ errors, dirty }}
                            maxLength={100}
                            t={t}
                        />
                    </div>
                    <div className="col-sm-12 mb-3">
                        <TextAreaInput
                            id="fullAddress"
                            name="fullAddress"
                            label={t("FULL_ADDRESS")}
                            placeholder=""
                            onChange={handleOnChange}
                            value={fullAddress}
                            validation={{ errors, dirty }}
                            rows={4}
                            maxLength={200}
                            t={t}
                        />
                    </div>

                </div>
            </div>

            <div className="row">

                <div className="col-6 my-3 dir-left">
                    <button
                        className="btn btn-lg btn-default btn-back "
                        onClick={() => {
                            isAttestationService === 1 ? navigation.go("attestation-service") : navigation.go("select-embassy");
                        }}
                        disabled={false}
                    >
                        {t("BACK")}
                    </button>
                </div>

                <div className="col-6 my-3  dir-right">
                    <button
                        className="btn btn-primary btn-lg"
                        onClick={() => {
                            values.isMobileValid
                                ? navigation.go("review-details")
                                : navigation.next();
                        }}
                        disabled={isStepInvalid()}
                    >
                        {t("PROCEED")}
                    </button>
                </div>
            </div>
        </>
    );
}

export default ReceiverDetails;
